import { render } from "./Cancel.vue?vue&type=template&id=0d12afa2&scoped=true"
import script from "./Cancel.vue?vue&type=script&lang=js"
export * from "./Cancel.vue?vue&type=script&lang=js"

import "./Cancel.vue?vue&type=style&index=0&id=0d12afa2&scoped=true&lang=css"

import exportComponent from "/home/luis/dev/nyxhotel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d12afa2"]])

export default __exports__